__webpack_require__.p = "https://ux-pool-dev.azurewebsites.net/";